import { getAuditApi } from '@/core/api/generatedApiClient';
import { rethrowHandledApiError } from '@/core/api/rethrowHandledApiError';
import type { ApiSettingType, AuditHistoryResponse } from '@/core/generated/api';

/** Загружает историю изменений редактируемых данных админки */
export const auditService = {
    /** Получает страницу истории продукта */
    async getProductHistory(
        productId: string,
        page: number,
        signal?: AbortSignal,
        pageSize = 20
    ): Promise<AuditHistoryResponse> {
        try {
            const response = await getAuditApi()
                .getProductHistory({
                    productId,
                    page,
                    pageSize,
                }, { signal });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },

    /** Получает страницу истории раздела настроек */
    async getVoxSettingsHistory(
        type: ApiSettingType,
        page: number,
        signal?: AbortSignal,
        pageSize = 20
    ): Promise<AuditHistoryResponse> {
        try {
            const response = await getAuditApi()
                .getVoxSettingsHistory({
                    type,
                    page,
                    pageSize,
                }, { signal });

            return response.data;
        } catch (error: unknown) {
            return rethrowHandledApiError(error);
        }
    },
};
